import echoClient from "./Echo.Client"
import type { EchoEndpointBuilder } from "./Echo.Slice"
import { EchoTag } from "./api/util/EchoTag"

const genesisCareEndpoints = (build: EchoEndpointBuilder) => ({
    echoGenesisCareIntegrationGetAllRecords: build.query({
        queryFn: (_: void) => echoClient.genesisCare.records(),
        providesTags: [EchoTag.Tenant, EchoTag.GenesisCareIntegration]
    }),
    echoGenesisCareIntegrationClearAllRecords: build.mutation({
        queryFn: (_: void) => echoClient.genesisCare.clear(),
        invalidatesTags: [EchoTag.GenesisCareIntegration]
    }),
    echoGenesisCareIntegrationAddRecords: build.mutation({
        queryFn: echoClient.genesisCare.add,
        invalidatesTags: [EchoTag.GenesisCareIntegration]
    })
})

export default genesisCareEndpoints
